import { render } from "./CoinRain.vue?vue&type=template&id=0fc5b794&scoped=true"
import script from "./CoinRain.vue?vue&type=script&lang=js"
export * from "./CoinRain.vue?vue&type=script&lang=js"

import "./CoinRain.vue?vue&type=style&index=0&id=0fc5b794&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc5b794"]])

export default __exports__